import styled from 'styled-components'

export default styled.section`
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 8px !important;
  border-radius: 4px;
  font-size: 16px;
  line-height: 1.4;
  overflow-wrap: anywhere;

  .title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    h4 {
      font-size: 18px;
      flex: 1;
      min-width: 0;
      margin: 0;
    }
  }

  .icon-container {
    flex-shrink: 0;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 6px 8px 4px !important;
  }
`
